// Interleave the elements of the array with the specified value, creating a new array with alternating elements from the original array and the provided value.

export const interleave = (arr: any[] = [], val: any) =>
  [].concat(...(arr.map((n) => [n, val]) as any)).slice(0, -1)
